export default "/assets/Icon/Callout.svg"